module.exports = __webpack_public_path__ + "img/Matt.01359984.png";